import angular from 'angular';

import Signin from './signin/signin';
import Profile from './profile/profile';
import Deposit from './customer/deposit/deposit';
import Overview from './customer/overview/overview';
import Withdrawal from './customer/withdrawal/withdrawal';
import Productwallet from './customer/productwallet/productwallet';
import Peertopeer from './customer/peertopeer/peertopeer';
import Outstandingbet from './customer/outstandingbet/outstandingbet';
import Bethistory from './customer/bethistory/bethistory';
import Acrewards from './acrewards/acrewards';
import Resetpassword from './resetpassword/resetpassword';
import ForgotPassword from './forgotpassword/forgotpassword';
import Activation from './activation/activation';
import Zendesk from './zendesk/zendesk';
import Settings from './settings/settings';
import Requests from './requests/requests';

// TODO remove CustomerModule.
import CustomerModule from './customer/customer.module';
import MarketingModule from './marketing/marketing';

let pagesModule = angular.module('pages', [
  Signin,
  Profile,
  Deposit,
  Overview,
  Withdrawal,
  Productwallet,
  Peertopeer,
  Outstandingbet,
  Bethistory,
  Acrewards,
  Resetpassword,
  ForgotPassword,
  Activation,
  CustomerModule,
  MarketingModule,
  Zendesk,
  Settings,
  Requests
])

.name;

export default pagesModule;



// WEBPACK FOOTER //
// ./client/app/pages/pages.module.js